module.exports = __webpack_public_path__ + "img/nyc-dynamo.5333754f.jpg";